module.exports = "/_next/static/images/8a24413a16618e76f495fea3a6f8bf05-rewards-home-card@0.75x.png";